/* Komplektu lapa: variantu izvēle, cenas pārrēķins, abu preču pievienošana grozam. */
(function () {
  document.documentElement.classList.add('kp-js');

  const money = (cents) => {
    const v = Math.round(cents);
    const int = Math.floor(v / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const dec = String(v % 100).padStart(2, '0');
    return `${int},<sup>${dec}€</sup>`;
  };
  const abs = (u) => { try { return new URL(u, location.href).href; } catch (e) { return u; } };

  // PVN pārslēgs galvenē (T-Selector): palīgteksts "(ar PVN)" vai aktīvā poga "Privātpersona"
  const vatOn = () => {
    const helper = document.querySelector('.tax-price-helper');
    if (helper) return /ar PVN/i.test(helper.textContent);
    const act = document.querySelector("[class*='vat-switcher'] .active");
    return !!act && /ar PVN|Privātpersona/i.test(act.textContent);
  };
  const vatFactor = (rate) => (vatOn() ? 1 + rate / 100 : 1);

  // Piegādes datumi kā produkta lapā (Delivery Estimator): tas pats noteikums un tas pats aprēķins, lai pasūtījuma rindām ir datums.
  // Datumu funkcijas pārņemtas no app (estimator.2.0.js) bez izmaiņām, lai virkne sakrīt ar produkta lapu.
  const etaEarly = window.estimatorConfig || null;
  const etaCfg = () => {
    const app = window['Estimator-App'];
    const c = app && app.getSettings ? app.getSettings() : null;
    return c && c.rules ? c : window.estimatorConfig || etaEarly;
  };
  const blank = (x) => {
    const t = Object.prototype.toString.call(x);
    if (t === '[object Undefined]' || t === '[object Null]') return true;
    if (t === '[object String]') return x.trim() === '';
    if (t === '[object Object]') return !Object.keys(x).length;
    if (t === '[object Array]') return !x.length;
    if (t === '[object Boolean]') return x === false;
    return false;
  };
  const etaText = (cfg, key, langs) => {
    const pick = (o) => key.split('.').reduce((a, k) => (a && k in a ? a[k] : undefined), o);
    const lim = (cfg.permissions || {}).languages;
    const n = lim === '∞' ? 99999999 : parseInt(lim);
    const loc = String(cfg.locale || '').toLowerCase().split(/[-_]/)[0];
    const own = n > 0 && Object.keys(langs).filter((k) => k !== 'default').slice(0, n).includes(loc) ? pick(langs[loc]) : undefined;
    if (!blank(own)) return own;
    const def = pick(langs.default || {});
    return blank(def) ? '' : def;
  };
  const etaDates = (conf, rule) => {
    const biz = conf.businessSettings, adv = conf.advancedSettings;
    const hol = biz.holidays, cut = biz.cutoffTimes;
    const tz = blank(biz.timezone) || biz.timezone === 'default' ? Intl.DateTimeFormat().resolvedOptions().timeZone : biz.timezone;
    const dl = adv.dates && !blank(adv.dates.locale) ? adv.dates.locale : 'en-US';
    const nowIn = (d = null, { locale = 'en-US', hour12 = false, timeZone = null } = {}) => {
      const o = { hour12 };
      if (!blank(timeZone)) o.timeZone = timeZone;
      return new Date((blank(d) ? new Date() : new Date(d)).toLocaleString(locale, o));
    };
    const fmt = (d, f = 'Y-m-d', opt = {}) => {
      if (!(Object.prototype.toString.call(d) === '[object Date]' && !isNaN(d.getTime()))) return null;
      const locale = opt.locale || dl;
      const day = d.getDate(), wd = d.getDay(), y = d.getFullYear(), h = d.getHours(), mi = d.getMinutes(), mo = d.getMonth() + 1, s = d.getSeconds();
      const suf = ['st', 'nd', 'rd'];
      const S = suf[(day % 10) - 1] == null || [11, 12, 13].includes(day % 100) ? 'th' : suf[(day % 10) - 1];
      let dd = day, mm = mo;
      if (opt.isRemoveLeadingZero !== true) { dd = String(day).padStart(2, '0'); mm = String(mo).padStart(2, '0'); }
      const doy = Math.floor((d - new Date(y, 0, 1)) / 86400000);
      const g = (h + 24) % 12 || 12;
      const two = (x) => (String(x).length < 2 ? '0' : '') + x;
      const off = d.getTimezoneOffset();
      let zone = (off > 0 ? '-' : '+') + String(Math.floor(Math.abs(off) / 60)).padStart(2, '0') + ':' + String(Math.abs(off) % 60).padStart(2, '0');
      if (!blank(opt.timezone)) {
        const part = new Intl.DateTimeFormat(locale, { timeZone: opt.timezone, hour12: false, hour: '2-digit', minute: '2-digit', timeZoneName: 'shortOffset' }).formatToParts();
        const m = ((part.find((p) => p.type === 'timeZoneName') || {}).value || 'UTC').match(/GMT([+-])(\d{1,2})(?::(\d{2}))?/);
        zone = m ? m[1] + String(m[2]).padStart(2, '0') + ':' + String(m[3] || '00').padStart(2, '0') : 'Z';
      }
      const map = {
        d: dd, D: d.toLocaleDateString(locale, { weekday: 'short' }), j: day, l: d.toLocaleDateString(locale, { weekday: 'long' }), N: wd, S,
        z: Math.floor((d - new Date(y, 0, 0)) / 7200000), W: Math.ceil((wd + 1 + doy) / 7),
        F: d.toLocaleDateString(locale, { month: 'long' }), m: mm, M: d.toLocaleDateString(locale, { month: 'short' }), n: mo,
        t: new Date(y, mo - 1, 0).getDate(), L: (y % 4 == 0 && y % 100 != 0) || y % 400 == 0 ? 1 : 0, o: y, Y: y, y: y.toString().substr(-2),
        a: h >= 12 ? 'pm' : 'am', A: h >= 12 ? 'PM' : 'AM', g, G: h, h: two(g), H: two(h), i: two(mi), s: two(s),
        c: y + '-' + mm + '-' + dd + 'T' + two(h) + ':' + two(mi) + ':' + two(s) + zone,
      };
      return f.replace(/\\?([a-zA-Z])/g, (x, c) => map[c] || c);
    };
    const work = (d, days) => days[d.getDay()];
    const isHol = (d) => hol.includes(fmt(d, 'Y-m-d'));
    const dayName = (d) => d.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
    const add = (start, n, days) => {
      const d = new Date(start);
      let k = 0;
      while (k < n) { d.setDate(d.getDate() + 1); if (work(d, days) && !isHol(d)) k++; }
      while (!work(d, days) || isHol(d)) d.setDate(d.getDate() + 1);
      const [hh, mm] = cut[dayName(d)].split(':').map(Number);
      d.setHours(hh, mm, 0, 0);
      return d;
    };
    const today = nowIn(null, { locale: 'en', timeZone: tz });
    const late = work(today, biz.workingDays.dispatch) && !isHol(today) && (() => {
      const c = cut[dayName(today)];
      if (!c) return false;
      const [hh, mm] = c.split(':').map(Number);
      const t = nowIn(today, { locale: 'en', timeZone: tz });
      t.setHours(hh, mm, 0, 0);
      return today > t;
    })() ? 1 : 0;
    const pMin = add(today, parseInt(rule.dates.dispatch.minDay) + late, biz.workingDays.dispatch);
    const pMax = add(today, parseInt(rule.dates.dispatch.maxDay) + late, biz.workingDays.dispatch);
    const dMin = add(pMax, rule.dates.delivery.minDay, biz.workingDays.delivery);
    const dMax = add(pMax, rule.dates.delivery.maxDay, biz.workingDays.delivery);
    const out = (d) => fmt(new Date(fmt(d, 'c', { timezone: tz })), adv.dates.format, { isRemoveLeadingZero: adv.dates.isRemoveZero });
    return {
      '{{preparation_min_date}}': out(pMin), '{{preparation_max_date}}': out(pMax),
      '{{delivery_min_date}}': out(dMin), '{{delivery_max_date}}': out(dMax),
    };
  };
  const etaProps = (p, v) => {
    const cfg = etaCfg();
    const conf = cfg && cfg.configuration;
    if (!conf || blank(cfg.rules)) return null;
    const gen = conf.generalSettings || {}, perm = cfg.permissions || {};
    if (gen.enable !== true || perm.cart !== true) return null;
    const tracked = v.tracked === 'shopify' && (v.policy === 'deny' || v.policy === 'continue');
    if (v.quantity <= 0 && !((!tracked && gen.isUnavailableProducts === true) || (v.policy === 'continue' && gen.isOversoldProducts === true))) return null;
    const order = (a, b) => (a.priority !== b.priority ? a.priority - b.priority : a.id - b.id);
    const unsure = [];
    const cond = (r) => (c) => {
      const eq = c.operator === '=', ne = c.operator === '!=';
      if (!blank(c.vendors)) return (eq && c.vendors.includes(p.vendor)) || (ne && !c.vendors.includes(p.vendor));
      if (!blank(c.productTypes)) return (eq && c.productTypes.includes(p.type)) || (ne && !c.productTypes.includes(p.type));
      if (!blank(c.tags)) return blank(p.tags) ? ne : c.tags.some((t) => (eq ? p.tags.includes(t) : !p.tags.includes(t)));
      if (!blank(c.productSkus)) return (eq && c.productSkus.includes(v.sku)) || (ne && !c.productSkus.includes(v.sku));
      if (!blank(c.locations)) { unsure.push(r); return false; }
      if (!blank(c.inventoryType)) {
        const q = v.quantity === undefined ? 0 : v.quantity, st = c.inventoryStock;
        return !!{ in_stock: q > 0, out_of_stock: q <= 0, custom_stock: (eq && q === st) || (ne && q !== st) || (c.operator === '>' && q > st) || (c.operator === '<' && q < st) }[c.inventoryType];
      }
      return false;
    };
    const hits = Object.values(cfg.rules).filter((r) => {
      const vis = r.visibility || {};
      if (!['all', 'collections', 'products', 'variants', 'automated'].includes(vis.type)) return false;
      const type = perm.conditions === true ? vis.type : 'all';
      if (type === 'all') return true;
      if (type === 'products') return !blank(vis.products) && vis.products.includes(p.id);
      if (type === 'variants') return !blank(vis.variants) && vis.variants.includes(v.id);
      if (type === 'collections') return !blank(vis.collections) && !blank(p.collections) && p.collections.some((id) => vis.collections.includes(id));
      const cs = (vis.automated && vis.automated.conditions) || [];
      const ok = cs.filter(cond(r));
      if (!ok.length) return false;
      return vis.automated.type === 'and' ? ok.length === cs.length : vis.automated.type === 'or';
    });
    hits.sort(order);
    const rule = (gen.isPriorityRule === true ? hits.slice(0, 1) : hits).filter((r) => blank(r.visibility.zipcodes))[0];
    // noliktavu nosacījumu app pārbauda savā serverī: datumu liekam tikai tad, ja šāds noteikums nevarētu uzvarēt
    if (unsure.some((r) => !rule || order(r, rule) < 0)) return null;
    if (!rule || rule.isCart !== true || !blank(rule.visibility.countries)) return null;
    const label = etaText(cfg, 'cartLabel', rule.languages), msg = etaText(cfg, 'cartMessage', rule.languages);
    if (blank(label) || blank(msg)) return null;
    const map = etaDates(conf, rule);
    const props = { [label]: msg.replace(new RegExp(Object.keys(map).join('|'), 'gi'), (m) => map[m]) };
    if (gen.cartDateMode === 'dynamic') props._estimator = btoa(rule.id);
    return props;
  };

  class KpBundle extends HTMLElement {
    connectedCallback() {
      const raw = this.querySelector('script[type="application/json"]');
      if (!raw) return;
      this.root = this.closest('.eskp');
      this.t = (k, fallback) => (this.root && this.root.dataset[k]) || fallback;
      this.data = JSON.parse(raw.textContent);
      this.pct = Number(this.dataset.pct) || 0;
      this.rate = Number(this.root && this.root.dataset.pvn) || 0;
      this.sel = {};
      this.variant = {};
      this.imgSeq = { galds: 0, kresls: 0 };
      this.imgUrl = {};
      this.btn = this.querySelector('[data-kp-add]');
      this.msg = this.querySelector('[data-kp-msg]');
      ['galds', 'kresls'].forEach((role) => {
        const p = this.data[role];
        const first = p.variants.find((v) => v.available) || p.variants[0];
        this.sel[role] = first ? [...first.options] : [];
        const img = this.querySelector(`[data-kp-img="${role}"]`);
        if (img) this.imgUrl[role] = abs(img.getAttribute('src'));
        this.querySelectorAll(`.kp-item[data-role="${role}"] input[type="radio"]`).forEach((input) => {
          input.addEventListener('change', () => {
            this.sel[role][Number(input.dataset.position) - 1] = input.value;
            this.update();
          });
        });
      });
      if (this.btn) this.btn.addEventListener('click', () => this.add());
      this.update();
    }

    find(role) {
      const p = this.data[role];
      if (p.hasOnlyDefault) return p.variants[0];
      const want = this.sel[role];
      return p.variants.find((v) => v.options.every((o, i) => o === want[i]));
    }

    swapImage(role, url) {
      const img = this.querySelector(`[data-kp-img="${role}"]`);
      if (!img || !url) return;
      const target = abs(url);
      if (this.imgUrl[role] === target) return;
      this.imgUrl[role] = target;
      const seq = ++this.imgSeq[role];
      img.style.opacity = '0';
      const n = new Image();
      n.onload = () => { if (seq !== this.imgSeq[role]) return; img.src = target; img.style.opacity = ''; };
      n.onerror = () => { if (seq === this.imgSeq[role]) img.style.opacity = ''; };
      n.src = target;
    }

    update() {
      let ok = true;
      ['galds', 'kresls'].forEach((role) => {
        const p = this.data[role];
        const v = this.find(role);
        this.variant[role] = v;
        if (!v || !v.available) ok = false;
        if (v && v.image) this.swapImage(role, v.image);
        this.querySelectorAll(`[data-kp-link="${role}"]`).forEach((a) => { a.href = v ? `${p.url}?variant=${v.id}` : p.url; });
        this.querySelectorAll(`.kp-item[data-role="${role}"] input[type="radio"]`).forEach((input) => {
          const pos = Number(input.dataset.position) - 1;
          const probe = [...this.sel[role]]; probe[pos] = input.value;
          const hit = p.variants.find((x) => x.available && x.options.every((o, i) => o === probe[i]));
          input.closest('.kp-pill').classList.toggle('is-off', !hit);
        });
      });
      const g = this.variant.galds, k = this.variant.kresls;
      const total = this.querySelector('[data-kp-total]'), was = this.querySelector('[data-kp-was]'), save = this.querySelector('[data-kp-save]'), vat = this.querySelector('[data-kp-vat]');
      if (g && k) {
        const f = vatFactor(this.rate);
        const chair = Math.round(k.price * (100 - this.pct) / 100);
        const sum = g.price + chair, full = g.price + k.price;
        total.innerHTML = money(sum * f);
        was.innerHTML = money(full * f);
        save.innerHTML = money((full - sum) * f);
        if (vat) vat.textContent = f > 1 ? this.t('tVatOn', '') : this.t('tVatOff', '');
      } else {
        total.textContent = '–'; was.textContent = '–'; save.textContent = '–';
      }
      if (this.btn) {
        this.btn.disabled = !ok;
        this.setMsg(ok ? '' : this.t('tOff', ''), ok ? '' : 'is-err');
      }
    }

    setMsg(text, cls) {
      if (!this.msg) return;
      this.msg.textContent = text;
      this.msg.className = 'kp-msg' + (cls ? ' ' + cls : '');
    }

    async add() {
      const g = this.variant.galds, k = this.variant.kresls;
      if (!g || !k || this.btn.classList.contains('is-busy')) return;
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const label = this.btn.querySelector('[data-kp-btn-text]');
      const orig = label.textContent;
      this.btn.classList.add('is-busy'); label.textContent = this.t('tBusy', '…'); this.setMsg('');
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      if (window.isEstimatorLoaded === true) for (let i = 0; i < 20 && !etaCfg(); i++) await new Promise((r) => setTimeout(r, 100));
      const item = (role, v) => {
        let properties = null;
        try { properties = etaProps(this.data[role], v); } catch (e) { /* bez datuma, kā līdz šim */ }
        return properties ? { id: v.id, quantity: 1, properties } : { id: v.id, quantity: 1 };
      };
      const body = { items: [item('galds', g), item('kresls', k)] };
      if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname; }
      try {
        const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const json = await res.json();
        if (json.status || !res.ok) throw new Error(json.description || json.message || 'cart');
        this.setMsg(this.t('tOk', ''), 'is-ok');
        if (window.publish && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'komplekti', productVariantId: g.id, cartData: json }); } catch (e) { /* nav kritiski */ }
        }
        if (cart && cart.renderContents) {
          if (cart.setActiveElement) cart.setActiveElement(this.btn);
          cart.classList.remove('is-empty');
          cart.renderContents(json);
        } else {
          window.location.href = `${root}cart`;
        }
      } catch (e) {
        this.setMsg(this.t('tErr', ''), 'is-err');
      } finally {
        this.btn.classList.remove('is-busy'); label.textContent = orig;
      }
    }
  }
  if (!customElements.get('kp-bundle')) customElements.define('kp-bundle', KpBundle);

  const initRoot = (root) => {
    if (!root || root.dataset.kpReady) return;
    root.dataset.kpReady = '1';
    // filtrs
    const chips = root.querySelectorAll('[data-kp-filter]');
    chips.forEach((chip) => chip.addEventListener('click', () => {
      chips.forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
      const f = chip.dataset.kpFilter;
      root.querySelectorAll('.kp-row').forEach((row) => { row.hidden = !!f && row.dataset.group !== f; });
    }));
    // lipīgā filtra josla zem tēmas galvenes
    const header = document.querySelector('.shopify-section-header-sticky, .shopify-section-header, #shopify-section-header');
    let raf = 0;
    const setTop = () => { raf = 0; const h = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0; root.style.setProperty('--kp-top', h + 'px'); };
    const queue = () => { if (!raf) raf = requestAnimationFrame(setTop); };
    setTop();
    setTimeout(setTop, 300); setTimeout(setTop, 1500);
    window.addEventListener('load', setTop);
    let late = 0;
    const queueLate = () => { queue(); clearTimeout(late); late = setTimeout(setTop, 450); };
    window.addEventListener('scroll', queueLate, { passive: true });
    window.addEventListener('resize', queue);
    if (header) {
      header.addEventListener('transitionend', queue);
      if ('ResizeObserver' in window) new ResizeObserver(queue).observe(header);
      if ('MutationObserver' in window) new MutationObserver(queueLate).observe(header, { attributes: true, attributeFilter: ['class', 'style'], subtree: true });
    }
    // ienākšana
    const rows = root.querySelectorAll('.kp-row');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
      rows.forEach((r) => io.observe(r));
      setTimeout(() => rows.forEach((r) => r.classList.add('is-in')), 2500);
    } else {
      rows.forEach((r) => r.classList.add('is-in'));
    }
  };
  const initAll = (scope) => (scope || document).querySelectorAll('.eskp').forEach(initRoot);
  initAll();
  document.addEventListener('shopify:section:load', (e) => { if (e.target) { e.target.querySelectorAll('.eskp').forEach((r) => { delete r.dataset.kpReady; }); initAll(e.target); } });
  // PVN pārslēgs galvenē: kad mainās palīgteksts vai pogas stāvoklis, pārrēķina visus komplektus
  let vatTimer = null;
  const updateAll = () => { clearTimeout(vatTimer); vatTimer = setTimeout(() => document.querySelectorAll('kp-bundle').forEach((b) => b.update && b.update()), 120); };
  document.addEventListener('click', (ev) => { if (ev.target.closest && ev.target.closest("[class*='vat-switcher']")) { updateAll(); setTimeout(updateAll, 600); } });
  if ('MutationObserver' in window) {
    new MutationObserver((ms) => {
      if (ms.some((m) => { const el = m.target.nodeType === 3 ? m.target.parentElement : m.target; return el && el.closest && el.closest(".tax-price-helper, [class*='vat-switcher']"); })) updateAll();
    }).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  }
})();
